import { render, staticRenderFns } from "./res.vue?vue&type=template&id=45fd8288&"
import script from "./res.vue?vue&type=script&lang=js&"
export * from "./res.vue?vue&type=script&lang=js&"
import style0 from "./res.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports